module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_3.f026e6cf.png";